import { Center, Spinner } from 'native-base'
import React from 'react'

import { Screen } from '../ScreenWrapper/Screen'

export const AppLoading: React.FC = () => {
  return (
    <Screen>
      <Center>
        <Spinner />
      </Center>
    </Screen>
  )
}

export default AppLoading
